import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { TransactionsPanelComponent } from './lib/transactions-panel.component'
import { TransactionsKey } from './panel-key'

export * from './lib/transactions.module'
export * from './panel-key'

export const TransactionsPanelConfig: PanelConfig = {
  key: TransactionsKey,
  title: 'Transactions',
  description:
    'Modify transactions by posting external transactions and adjusting transaction details.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: TransactionsPanelComponent,
  accessPermission: 'accessTransactionsPanel',
  isExternal: true,
}
